import styled from 'styled-components';
import { Fontw5s16h28 } from 'styles/commonCss';
import Url from 'lib/siteurls';
import { trackLinkClicked } from 'lib/analytics';

const Header = styled.header`
  position: fixed;
  z-index: 1000;
  background-color: var(--guidance-secondary);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Text = styled.span`
  ${Fontw5s16h28};
  color: var(--text-primary);
`;

const TextContainer = styled.div`
  padding: 3.5px 0;
`;

const FullscriptLink = styled.a`
  ${Fontw5s16h28};
`;

const trackLinkClick = (hashedAccountInfo) => () => {
  trackLinkClicked(
    'Fullscript',
    Url.fullscript,
    '/practitioners',
    '/practitioners',
    window.location.href,
    { hashedAccountInfo },
  );
};

const HeaderFullscript = ({ hashedAccountInfo }) => (
  <Header>
    <TextContainer>
      <Text>We are now on&nbsp;</Text>
      <FullscriptLink
        href={Url.fullscript}
        target='_blank'
        rel='noopener noreferrer'
        onClick={trackLinkClick(hashedAccountInfo)}
        aria-label='Seed on Fullscript®. Opens in a new tab.'
      >
        Fullscript®
      </FullscriptLink>
    </TextContainer>
  </Header>
);

export default HeaderFullscript;
